import script from "./DataentryStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataentryStatus.vue?vue&type=script&lang=ts&setup=true"

import "./DataentryStatus.vue?vue&type=style&index=0&id=006c5556&scoped=true&lang=scss"
import "./DataentryStatus.vue?vue&type=style&index=1&id=006c5556&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-006c5556"]])

export default __exports__